var chunkMapping = {
	"webpack_container_remote_messaging_extension_messaging_extension": [
		95240
	],
	"webpack_container_remote_user_extension_user_extension": [
		38802
	],
	"webpack_container_remote_integration_extension_integration_extension": [
		84248
	],
	"webpack_container_remote_account_extension_account_extension": [
		24410
	],
	"webpack_container_remote_team_extension_team_extension": [
		5446
	],
	"webpack_container_remote_number_extension_number_extension": [
		49879
	],
	"webpack_container_remote_conversations_center_ext_conversations_center_ext": [
		77147
	],
	"webpack_container_remote_calendar_mgmt_extension_calendar_mgmt_extension": [
		71480
	],
	"webpack_container_remote_voice_virtual_agent_extension_voice_virtual_agent_extension": [
		28296
	],
	"webpack_container_remote_live_monitoring_extension_live_monitoring_extension": [
		53573
	],
	"webpack_container_remote_call_timeline_extension_call_timeline_extension": [
		63018
	],
	"webpack_container_remote_flow_editor_extension_flow_editor_extension": [
		57104
	]
};
var idToExternalAndNameMapping = {
	"5446": [
		"default",
		"./team_extension",
		23263
	],
	"24410": [
		"default",
		"./account_extension",
		90461
	],
	"28296": [
		"default",
		"./voice_virtual_agent_extension",
		36999
	],
	"38802": [
		"default",
		"./user_extension",
		13785
	],
	"49879": [
		"default",
		"./number_extension",
		77601
	],
	"53573": [
		"default",
		"./live_monitoring_extension",
		13133
	],
	"57104": [
		"default",
		"./flow_editor_extension",
		20454
	],
	"63018": [
		"default",
		"./call_timeline_extension",
		28590
	],
	"71480": [
		"default",
		"./calendar_mgmt_extension",
		57417
	],
	"77147": [
		"default",
		"./conversations_center_ext",
		54367
	],
	"84248": [
		"default",
		"./integration_extension",
		85603
	],
	"95240": [
		"default",
		"./messaging_extension",
		4715
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}